import { render, staticRenderFns } from "./PatentBulletinCheck.vue?vue&type=template&id=047707ef&"
import script from "./PatentBulletinCheck.vue?vue&type=script&lang=js&"
export * from "./PatentBulletinCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports